const BROWSER_RUNTIME_SCRIPTS = Object.freeze([
  {
    key: 'sql-wasm',
    path: 'sql-wasm.js',
    ready: () => typeof window.initSqlJs === 'function'
  },
  {
    key: 'advanced-operations',
    path: 'main/advancedOperations.js',
    ready: () => typeof window.NivoraAdvancedOperations?.createAdvancedOperations === 'function'
  },
  {
    key: 'order-item-customization',
    path: 'main/orderItemCustomization.js',
    ready: () => (
      typeof window.NivoraOrderItemCustomization?.resolveOrderItemCustomization === 'function'
    )
  }
]);

function runtimeScriptUrl(path) {
  const prefix = String(process.env.PUBLIC_URL || '').replace(/\/+$/, '');
  return `${prefix}/${path}`;
}

function loadRuntimeScript(definition) {
  if (definition.ready()) return Promise.resolve();
  const selector = `script[data-nivora-runtime="${definition.key}"]`;
  let script = document.querySelector(selector);
  let created = false;
  if (!script) {
    script = document.createElement('script');
    script.src = runtimeScriptUrl(definition.path);
    script.async = true;
    script.dataset.nivoraRuntime = definition.key;
    created = true;
  }

  return new Promise((resolve, reject) => {
    const onLoad = () => {
      cleanup();
      if (definition.ready()) resolve();
      else reject(new Error(`Runtime ${definition.key} carregado sem expor o contrato esperado.`));
    };
    const onError = () => {
      cleanup();
      reject(new Error(`Não foi possível carregar o runtime ${definition.key}.`));
    };
    const cleanup = () => {
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onError);
    };
    script.addEventListener('load', onLoad, { once: true });
    script.addEventListener('error', onError, { once: true });
    if (created) document.head.appendChild(script);
  });
}

export async function loadBrowserPlatformRuntime() {
  if (window.electron?.db && window.electron?.auth) return;
  await Promise.all(BROWSER_RUNTIME_SCRIPTS.map(loadRuntimeScript));
}
